import { IconProps } from "../../utils/global-types/global-types";

const UpdatedIcon = ({ className, ...rest }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    fill="none"
    viewBox="0 0 18 18"
    className={className}
    {...rest}
  >
    <g fill="currentColor" clipPath="url(#clip0_6087_90100)">
      <path d="M15.827 2.756a.56.56 0 0 0-.41-.173.56.56 0 0 0-.41.173L13.82 3.932a7.1 7.1 0 0 0-2.233-1.426A6.9 6.9 0 0 0 9 2Q6.493 2 4.625 3.518q-1.869 1.516-2.461 3.96v.064a.28.28 0 0 0 .086.205.28.28 0 0 0 .205.086H4.27q.201 0 .273-.21.384-.91.484-1.066A4.6 4.6 0 0 1 6.72 4.926 4.6 4.6 0 0 1 9 4.333q1.832 0 3.18 1.249L10.924 6.84a.56.56 0 0 0-.173.41q0 .237.173.41a.56.56 0 0 0 .41.173h4.083a.56.56 0 0 0 .41-.173.56.56 0 0 0 .174-.41V3.167a.56.56 0 0 0-.173-.41M15.48 10.167h-1.75q-.2 0-.273.21-.383.91-.483 1.066a4.6 4.6 0 0 1-1.695 1.631A4.6 4.6 0 0 1 9 13.667q-.884 0-1.704-.328a4.7 4.7 0 0 1-1.468-.93l1.249-1.249a.56.56 0 0 0 .173-.41.56.56 0 0 0-.173-.41.56.56 0 0 0-.41-.174H2.583a.56.56 0 0 0-.41.174.56.56 0 0 0-.173.41v4.083a.56.56 0 0 0 .173.41.56.56 0 0 0 .41.174.56.56 0 0 0 .41-.173l1.176-1.176A6.96 6.96 0 0 0 8.964 16q2.498 0 4.356-1.518 1.86-1.516 2.443-3.96a.28.28 0 0 0-.078-.269.28.28 0 0 0-.205-.086"></path>
    </g>
    <defs>
      <clipPath id="clip0_6087_90100">
        <path fill="#fff" d="M2 2h14v14H2z"></path>
      </clipPath>
    </defs>
  </svg>
);

export default UpdatedIcon;
